import { connect } from "react-redux";
import {
    ToggleErrorModal,
    GetPDFInfo,
    SetUploadedPdfs
} from "../data/app/appActions";
import { withRouter } from "react-router-dom";
import UploadPDF from "../components/uploadPDF";

const mapStateToProps = state => ({
    subscribed: state.appReducer.subscribed,
    loading: state.loaderReducer.loading,
    modalOpen: state.appReducer.modalOpen,
    selectedPrescriberInfo: state.appReducer.selectedPrescriberInfo,
    errorModalOpen: state.appReducer.errorModalOpen,
    uploadedPdfs: state.appReducer.uploadedPdfs,
    scheduledVisits: state.appReducer.scheduledVisits,
    asyncOrders: state.appReducer.asyncOrders,
});

const mapDispatchToProps = dispatch => ({
    ToggleErrorModal: (data) => {
        dispatch(ToggleErrorModal(data));
    },
    GetPDFInfo: data => {
        dispatch(GetPDFInfo(data));
    },
    SetUploadedPdfs: data => {
        dispatch(SetUploadedPdfs(data));
    },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadPDF));
